import { Star } from "lucide-react";

export function Stars({ value = 0, size = 16, className = "" }) {
  const v = Number(value) || 0;
  return (
    <span className={`inline-flex items-center gap-0.5 ${className}`} aria-label={`${v} out of 5`} data-testid="stars">
      {[1, 2, 3, 4, 5].map((i) => (
        <Star key={i} style={{ width: size, height: size }}
          className={i <= Math.round(v) ? "fill-amber-400 text-amber-400" : "fill-transparent text-slate-300"} />
      ))}
    </span>
  );
}

export function StarInput({ value = 0, onChange, size = 30 }) {
  return (
    <span className="inline-flex items-center gap-1" data-testid="star-input">
      {[1, 2, 3, 4, 5].map((i) => (
        <button type="button" key={i} onClick={() => onChange(i)} data-testid={`star-${i}`}
          className="transition hover:scale-110" aria-label={`${i} star`}>
          <Star style={{ width: size, height: size }}
            className={i <= value ? "fill-amber-400 text-amber-400" : "fill-transparent text-slate-300"} />
        </button>
      ))}
    </span>
  );
}

export function RatingDistribution({ dist = {}, total = 0 }) {
  return (
    <div className="space-y-1" data-testid="rating-distribution">
      {[5, 4, 3, 2, 1].map((star) => {
        const n = dist[String(star)] || 0;
        const pct = total ? Math.round((n / total) * 100) : 0;
        return (
          <div key={star} className="flex items-center gap-2 text-xs text-slate-500">
            <span className="w-8 shrink-0">{star}★</span>
            <div className="h-2 flex-1 overflow-hidden rounded-full bg-slate-100">
              <div className="h-full rounded-full bg-amber-400" style={{ width: `${pct}%` }} />
            </div>
            <span className="w-8 shrink-0 text-right">{n}</span>
          </div>
        );
      })}
    </div>
  );
}
